import * as AT from "src/core/drops/store/drops.constants";
import { IDrop } from "src/core/drops/api/drops.api";

export type DropActions = IPurgeDrops | ISetDrop |IPurgeUserDrops | ISetUserDrops;

interface IPurgeDrops {
  type: AT.PURGE_DROPS;
}

export const purgeDrops = (): IPurgeDrops => {
  return { type: AT.PURGE_DROPS };
};

interface ISetDrop {
  type: AT.SET_DROP;
  drop: IDrop | null;
}

export const setDrop = (drop: IDrop | null): ISetDrop => {
  return {
    type: AT.SET_DROP,
    drop
  };
};

interface IPurgeUserDrops {
  type: AT.PURGE_USER_DROPS
}

interface ISetUserDrops {
  type: AT.SET_USER_DROPS
  drops: IDrop[] | null
}

export const purgeUserDrops = (): IPurgeUserDrops => {
  return { type: AT.PURGE_USER_DROPS };
};

export const setUserDrops = (drops: IDrop[] | null): ISetUserDrops => {
  return {
    type: AT.SET_USER_DROPS,
    drops
  };
};
